import React, { useEffect, useState } from "react";
import { Recorder } from "react-voice-recorder";
import "react-voice-recorder/dist/index.css";

import PropTypes from "prop-types";
import UploadVid from "./UploadVid";
import * as images from "../../../constants/Images";
import { Modal } from "@material-ui/core";
import { CircularProgressWithLabel } from "./UploadDocument";
import Loadspinner from "../../../common/Loadspinner";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { progressAudio, uploadAudioRec } from "../../../redux/actions";
// import { logEvent } from "firebase/analytics";
// import { analytics } from "../../../firebase";
import CommonConstants from "../../../constants/CommonConstants";

function AudioRec(props) {
  const toastId = React.useRef(null);
  const [isLoading, setLoading] = useState(false);
  const [audioDetails, setAudioDetails] = useState(
    props.audioDetails || {
      url: null,
      blob: null,
      chunks: null,
      duration: { h: null, m: null, s: null },
    }
  );
  console.log("audiodetaisls----", audioDetails);
  const [audio, setAudio] = useState(props.audioBlob);
  const [audioName, setAudioName] = useState(props.audioFileName);
  const [isrecorded, setRecorded] = useState(props.audioBlob ? true : false);
  const [isUploaded, setUploaded] = useState(true);
  const [videoId, setVideoId] = useState(props.audioId);
  const [firstToken, setToken] = useState("");
  const [isProgress, setProgress] = useState(false);
  const [progressStatus, setProgStatus] = useState(0);
  const [thumbnailId, setThumbnailId] = useState(props.thumbnailId);
  const [transcriptionData, setTranscriptionData] = useState(
    props.audioTranscription
  );
  const [transcriptionString, setTranscriptionString] = useState(
    props.transcriptionString
  );
  const [editText, setEditText] = useState("");

  const [showModal, setModal] = useState(true);
  const [showNextModal, openNextModal] = useState(false);
  console.log("🚀 ~ file: AudioRec.js:45 ~ AudioRec ~ showNextModal:", showNextModal);

  const [isAudio, setRecoAudio] = useState(false);
  // const [audioBlob, setAudioBlob] = useState();
  const dispatch = useDispatch();

  const closeModal = () => {
    setModal(false);
    props.handleModal(true);
  };

  useEffect(() => {
    getToken();
  }, []);

  const handleAudioUpload = (file) => {
    let blob = file.slice(0, file.size, "audio/webm");

    let timestamp = Date.now();
    let newFile = new File([blob], `audio${timestamp}.webm`, {
      type: "audio/webm",
    });
    // setAudioBlob(newFile);
    // uploadAudio(newFile);
    setAudioName(newFile.name);
    uploadVideoTrans(newFile);
    // //logEvent(analytics(), "uploadAudioRecording");
  };

  // const uploadAudio = async (audioFile) => {
  //   let fileData = new FormData();
  //   fileData.append("file", audioFile);

  //   let resp = await CreateKnowledgeService.fileUpload(fileData, "audios");

  //   if (resp.status.toLowerCase() == "success") {
  //     setAudio(resp.result[0]);
  //   }
  // };

  const handleRest = () => {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: null,
        m: null,
        s: null,
      },
    };
    setAudioDetails(reset);
    setUploaded(false);
  };

  //video transcription
  const uploadVideoTrans = async (newFile) => {
    try {
      setLoading(true);
      let fileData = new FormData();
      fileData.append("file", newFile);

      let response = await CreateKnowledgeService.fileUpload(
        fileData,
        "audios"
      );

      if (response.status.toLowerCase() == "success") {
        setAudio(response.result[0]);
      }

      // const knowledgeData = new FormData();
      // knowledgeData.append("", newFile);
      // let resp = await CreateKnowledgeService.uploadVideo(
      //   firstToken,
      //   knowledgeData,
      //   newFile.name
      // );
      // if (resp) {
      //   let { id } = resp;
      //   setVideoId(id);
      //   getDetails(firstToken, id, newFile.name, response.result[0]);
      // } else {
      //   toast("An error occurred while uploading the audio file. Please try again later.");
      // }
      closeModal();
      // notify();
      setLoading(false);
      dispatch(progressAudio(100));
      openNextModal(true);
      // update();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getDetails = async (firstToken, id, audioFileName, audio) => {
    setProgress(true);
    let resp = await CreateKnowledgeService.getVideoDetails1(firstToken, id);

    if (
      resp.results[0].processingProgress != "100%" &&
      resp.results[0].processingProgress != ""
    ) {
      setTimeout(
        () => (resp = getDetails(firstToken, id, audioFileName, audio)),
        3000
      );
      let status = parseInt(resp.results[0].processingProgress);
      setProgStatus(status);
      dispatch(progressAudio(status));
    } else if (resp.results[0].processingProgress == "") {
      setProgress(false);
      toast(
        "An error occurred while retrieving the audio/video file. Please try again later."
      );
    } else {
      dispatch(progressAudio(100));
      setThumbnailId(resp.results[0].thumbnailId);
      getVideoToken(id);
      let response = await CreateKnowledgeService.getVideoToken(id);
      if (response) {
        let res = await CreateKnowledgeService.getTranscription(id, response);
        if (res) {
          let data = {
            transcript: res.videos[0].insights.transcript,
          };
          let transcript = JSON.stringify(data);
          setTranscriptionString(transcript);
          let rets = transcript.replace("/", "");
          let json_trans = JSON.parse(rets);
          setTranscriptionData(json_trans.transcript);
          update();

          dispatch(
            uploadAudioRec(
              audioFileName,
              id,
              resp.results[0].thumbnailId,
              json_trans.transcript,
              "audio",
              audio,
              audioDetails
            )
          );
        }
      }
    }
  };

  const notify = () =>
    (toastId.current = toast.info(
      "Uploading audio, check progress in Notification tab!",
      { autoClose: false, theme: "dark" }
    ));

  const update = () =>
    toast.update(toastId.current, {
      render: "upload done",
      type: toast.TYPE.INFO,
      autoClose: 5000,
    });

  const getVideoToken = async (id) => {
    let res = await CreateKnowledgeService.getVideoToken(id);
    if (res) {
      getTranscriptionData(id, res);
    }
  };

  const getTranscriptionData = async (id, tok) => {
    let res = await CreateKnowledgeService.getTranscription(id, tok);
    if (res) {
      let data = {
        transcript: res.videos[0].insights.transcript,
      };
      let transcript = JSON.stringify(data);
      setTranscriptionString(transcript);
      let rets = transcript.replace("/", "");
      let json_trans = JSON.parse(rets);
      setTranscriptionData(json_trans.transcript);
    }
    setUploaded(true);
    setRecorded(true);
    setProgress(false);
  };

  //token

  const getToken = async () => {
    const res = await CreateKnowledgeService.firstApi();
    if (res) {
      setToken(res);
    }
  };

  //edit transcription

  const showEditModal = (actualText) => {
    setEditText(actualText);
  };
  const closeEditModal = () => {
    setEditText("");
  };

  const setEditedText = (e) => {
    setEditText(e.target.value);
  };

  const editTranscription = (editId) => {
    let transArray = transcriptionData;
    transArray.map((item) => {
      item.id == editId ? (item.text = editText) : null;
    });
    setTranscriptionData(transArray);
    closeEditModal();
  };

  return (
    <div>
      <Loadspinner
        filename="AudioRec.js"
        isLoading={isLoading}
        isMiddle="true"
      />

      {/* <div
        data-bs-toggle="modal"
        data-bs-target="#record-audio"
        style={{ cursor: "pointer", fontSize: "10px" }}
      >
        <img src={images.audio_rec} className="header-navimg-av" />
        <span className="header-text">Record Audio</span>
      </div>
      <div
        className="modal fade"
        id="record-audio"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      > */}
      <Modal
        open={showModal && !showNextModal}
        onClose={closeModal}
        className={
          isrecorded &&
          transcriptionString != null &&
          transcriptionString != "{}" &&
          transcriptionString != ""
            ? "modal-dialog modal-dialog-centered modal-xl"
            : "modal-dialog modal-dialog-centered modal-lg"
        }
      >
        <div className="modal-content">
          <div className="modal-header">
            <Modal
              disablePortal
              disableEnforceFocus
              disableAutoFocus
              open={isProgress}
              style={{ background: "transparent" }}
            >
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}
              >
                <CircularProgressWithLabel
                  value={Number.isNaN(progressStatus) ? 0 : progressStatus}
                  style={{ width: "100px" }}
                />
                <p style={{ margin: "25px", color: "white" }}>
                  Uploading audio
                </p>
              </div>
            </Modal>
            <h5 className="modal-title">Record and upload audio</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={closeModal}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div
              className="display-row justify-space-around"
              style={{ maxHeight: "75vh" }}
            >
              <div style={{ width: "100vw" }}>
                <Recorder
                  record={true}
                  title={"New audio recording"}
                  audioURL={audioDetails.url}
                  // showUIAudio
                  handleAudioStop={(data) => {
                    setAudioDetails(data);
                    setUploaded(false);
                  }}
                  handle
                  OnChange={(value) => this.handleOnChange(value, "firstname")}
                  handleAudioUpload={(data) =>
                    !isLoading && handleAudioUpload(data)
                  }
                  handleRest={() => handleRest()}
                  mimeTypeToUseWhenRecording="audio/webm"
                  uploadButtonDisabled={isUploaded}
                />
                {audioDetails.url && (
                  <audio
                    src={audioDetails.url}
                    controls
                    style={{
                      position: "absolute",
                      top: "38%",
                      margin: "10px 230px",
                    }}
                  />
                )}
              </div>
              {isrecorded &&
              transcriptionString != null &&
              transcriptionString != "{}" &&
              transcriptionString != "" ? (
                transcriptionData.length > 0 ? (
                  <div
                    className="display-col  card transcript-card"
                    style={{ width: "58%", padding: "5px", maxHeight: "400px" }}
                  >
                    <h6>Transcription</h6>
                    {transcriptionData.map((transc) => {
                      let target = `#audiomodal${transc.id}`;
                      let modalId = `audiomodal${transc.id}`;
                      return (
                        <div key={transc.id} className="card-body display-row ">
                          <p>{transc.instances[0]?.start}</p>
                          <span style={{ marginLeft: "7px" }}>
                            {transc.text}
                          </span>
                          <img
                            src={images.edit}
                            className="edit-img"
                            data-bs-toggle="modal"
                            data-bs-target={target}
                            onClick={() => showEditModal(transc.text)}
                          />
                          <div
                            className="modal fade"
                            id={modalId}
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabIndex="-1"
                            aria-labelledby="staticBackdropLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered ">
                              <div className="modal-content edit-modal">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="staticBackdropLabel"
                                  >
                                    Edit
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={closeEditModal}
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <input
                                    type="text"
                                    value={editText}
                                    className="edit-input form-control"
                                    onChange={setEditedText}
                                    autoComplete={
                                      CommonConstants.autoCompleteInput
                                    }
                                  />
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={closeEditModal}
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => editTranscription(transc.id)}
                                    data-bs-dismiss="modal"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null
              ) : null}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={closeModal}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => {
                openNextModal(true);
                // closeModal();
              }}
              disabled={!isrecorded}
              data-bs-dismiss="modal"
              data-bs-toggle="modal"
              data-bs-target="#audio-upload"
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
      {/* </div> */}
      {showNextModal && (
        <UploadVid
          isAudio={true}
          attachment={audio}
          fileName={audioName}
          videoId={videoId}
          thumbnailId={thumbnailId}
          transcription={transcriptionString}
          handleModal={openNextModal}
          handlePrevious={setModal}
          type="audio/webm"
        />
      )}
    </div>
  );
}

export default AudioRec;

AudioRec.propTypes = {
  handleModal: PropTypes.func,
  audioBlob: PropTypes.object,
  audioTranscription: PropTypes.array,
  audioFileName: PropTypes.string,
  thumbnailId: PropTypes.string,
  audioId: PropTypes.string,
  transcriptionString: PropTypes.string,
  audioDetails: PropTypes.object,
};
